import { Container } from "@/types/v2";

/**
 * Retrieves the display name of a container based on its unique identifier.
 * @param {string} id - The unique identifier of the container.
 * @param {Container[]} containers - The array of container objects to search.
 * @returns {string} Returns the display name of the container if found; otherwise, returns a default value of "Unknown Container". If the container does not have a display name, returns the identifier.
 */
export function getContainerName(id: string, containers: Container[]) {
  const container = containers.find((c) => c.id === id);
  if (!container) {
    return "Unknown Container";
  }
  return container.displayName ?? id;
}
